const getTime = value => {
  const parsedValue = typeof value === 'string' ? new Date(value) : value;
  return parsedValue !== null && parsedValue !== void 0 && parsedValue.getTime ? parsedValue.getTime() : undefined;
};

const getNumber = (amount = '', decimalSeparator = ',') => {
  if (typeof amount === 'number') {
    return amount;
  }

  if (amount === null || !amount.length) {
    return undefined;
  }

  let value;

  if (decimalSeparator === ',') {
    // replace digit seperator then replace decimal separator
    value = Number(amount.replace(/\./g, '').replace(',', '.'));
  } else {
    // replace digit seperator
    value = Number(amount.replace(/,/g, ''));
  }

  return Number.isNaN(value) ? undefined : value;
};

const getString = value => {
  if (value) {
    return String(value).toLowerCase();
  }

  return undefined;
};

const guess = value => {
  if (typeof value === 'boolean') {
    return !!value;
  }

  return isNaN(value) ? getString(value) : Number(value);
};

const compareBasic = (a, b) => {
  // places undefined values first in ascending order instead of descending
  if (a !== undefined && b === undefined) {
    return 1;
  }

  return a === b ? 0 : a > b ? 1 : -1;
};

const sortTypes = {
  datetime: (rowA, rowB, columnId) => {
    const a = getTime(rowA.values[columnId]);
    const b = getTime(rowB.values[columnId]);
    return compareBasic(a, b);
  },
  string: (rowA, rowB, columnId) => {
    const a = getString(rowA.values[columnId]);
    const b = getString(rowB.values[columnId]);
    return compareBasic(a, b);
  },
  number: (rowA, rowB, columnId) => {
    const a = getNumber(rowA.values[columnId]);
    const b = getNumber(rowB.values[columnId]);
    return compareBasic(a, b);
  },
  boolean: (rowA, rowB, columnId) => {
    const a = !!rowA.values[columnId];
    const b = !!rowB.values[columnId];
    return compareBasic(a, b);
  },
  auto: (rowA, rowB, columnId) => {
    const a = guess(rowA.values[columnId]);
    const b = guess(rowB.values[columnId]);
    return compareBasic(a, b);
  }
};

export { sortTypes };
//# sourceMappingURL=sortTypes.js.map
